import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

@Component({
  selector: 'a-datepicker',
  templateUrl: 'a-datepicker.component.html',
  styleUrls: ['a-datepicker.component.scss'],
})
export class ADatepickerComponent implements OnInit {

  @ViewChild(DaterangepickerDirective, { static: false }) datePicker: DaterangepickerDirective;
  @Input() label = '';
  @Input() grayBg = true;
  @Input() isOptional = false;
  @Input() control: any = new FormControl();
  
  locale = {
    format: 'DD.MM.YYYY',
    displayFormat: 'DD.MM.YYYY'
  };
  dateRange = null;

  constructor() {
  }

  ngOnInit(): void {
    if (this.control.value) {
      // this.dateRange = this.control.value;
      this.dateRange = {
        start: dayjs.utc(this.control.value.start),
        end: dayjs.utc(this.control.value.end)
      }
    }
  }

  clear() {
    if (this.datePicker) {
      this.control.reset();
      this.datePicker.clear();
    }
  }

  clearClicked() {
    if (this.datePicker) {
      this.control.reset();
    }
  }

  datesUpdated(val) {
    if (val && val.startDate && val.endDate) {
      // this.control.setValue({ 
      //   start: val.startDate.utc(true).format('DD.MM.YYYY'),
      //   end: val.endDate.utc(true).format('DD.MM.YYYY')
      // });
      this.control.setValue({ 
        start: val.startDate.utc().format(),
        end: val.endDate.utc().format()
      });
    }
  }

  openDatepicker() {
    this.datePicker.open();
  }

}
